import { render, staticRenderFns } from "./MyShortcutsPopoverItem.vue?vue&type=template&id=2b2a61a3&"
import script from "./MyShortcutsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./MyShortcutsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports